module.exports = __webpack_public_path__ + "img/search.83d7b2ac.svg";